import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Folder Open Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M250.077 104.077a17.92 17.92 0 0 0-14.56-7.437h-17.92V78.72c0-9.896-8.023-17.92-17.92-17.92H122.03L90.972 37.506a18.08 18.08 0 0 0-10.752-3.584H20.48c-9.897 0-17.92 8.023-17.92 17.92v161.278a8.96 8.96 0 0 0 8.96 8.96h200.59a8.96 8.96 0 0 0 8.5-6.127l31.908-95.725a17.98 17.98 0 0 0-2.441-16.15M80.22 51.841l33.443 25.088a8.96 8.96 0 0 0 5.376 1.792h80.639v17.92H53.822a17.92 17.92 0 0 0-17.002 12.252l-16.34 49.01V51.842Zm125.438 152.318H23.952l29.87-89.599h181.695Z" }, null, -1)
  ]))]))
}
export default { render: render }